import { ITimekitComponent } from '../timekit-tabs/timekit-tabs.component';
import { ThemingService } from 'src/app/theming.service';
import { SettingsService } from 'src/app/settings.service';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-timekit-schedule',
  templateUrl: './timekit-schedule.component.html',
  styleUrls: ['./timekit-schedule.component.scss']
})

export class TimekitScheduleComponent implements ITimekitComponent, OnInit {
  @Input() data: any;
    listingAppointments = true;
    listingCreateAppointment = true;
    listingBlockedSlots = true;
    activeTab: 'resource' | 'projects' | 'blocked' = 'resource';

    constructor(
      public themingService: ThemingService,
      public settingsService: SettingsService,
    ) {}

    ngOnInit(): void {}

    setActiveTab(tab: 'resource' | 'projects' | 'blocked') {
      this.activeTab = tab;
    }

    getListingAppointments(): boolean {
      return this.settingsService.getListingAppointments();
    }

    getListingCreateAppointment(): boolean {
      return this.settingsService.getListingCreateAppointment();
    }

    getListingBlockedSlots(): boolean {
      return this.settingsService.getListingBlockedSlots();
    }
  }
